// export const API_BASE_URL = "http://stagingwebsites.info:5018";
export const API_BASE_URL = "https://kim-api.stagingwebsites.info";
// export const API_BASE_URL = "http://localhost:5000";
// export const API_BASE_URL = "https://api.sparkscribe.ai"; // prodution